import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import NavLink from '../nav-link/NavLink';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    color: palette.navBar.color,
    fontSize: '12px',
    fontFamily: 'Montserrat',
    lineHeight: '15px',
    letterSpacing: '0.16px',
    alignItems: 'center',
    display: 'flex',
    '&:hover': {
      textDecoration: 'none',
      color: palette.navBar.hover,
    },
  },
  active: {
    color: palette.navBar.active,
  },
}), { name: 'MainBarLink' });

type Props = React.ComponentProps<typeof NavLink>;

const MainBarLink = ({ className, ...props }: Props) => {
  const classes = useStyles();

  return (
    <NavLink
      className={clsx(classes.root, className)}
      activeClassName={classes.active}
      {...props}
    />
  );
};

export default MainBarLink;
